import { Icon } from '@doordash/design-language';
import { IconButton } from '@doordash/component-button';
import { IconContainer } from './styles.js';
import PropTypes from 'prop-types';
import React from 'react';
import { ListCellSide } from './types.js';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var ConditionalIconButton = function ConditionalIconButton(_ref) {
  var renderIconSpacer = _ref.renderIconSpacer,
      sharedColor = _ref.sharedColor,
      iconAlignment = _ref.iconAlignment,
      side = _ref.side,
      iconProps = _ref.iconProps,
      columnProps = _objectWithoutProperties(_ref, ["renderIconSpacer", "sharedColor", "iconAlignment", "side", "iconProps"]);

  // Need to destructure these in stages so that TS can know what it is working with
  var _ref2 = iconProps || {},
      onClick = _ref2.onClick,
      tag = _ref2.tag,
      target = _ref2.target,
      href = _ref2.href;

  var _ref3 = iconProps || {},
      color = _ref3.color;

  var _ref4 = iconProps || {},
      type = _ref4.type,
      accessibilityLabel = _ref4.accessibilityLabel,
      size = _ref4.size,
      additionalIconProps = _objectWithoutProperties(_ref4, ["type", "accessibilityLabel", "size"]);

  var shouldBeButton = !!onClick;
  var Component = shouldBeButton ? IconButton : Icon;
  var props = shouldBeButton ? _objectSpread({
    size: size || IconButton.Sizes.Medium,
    type: IconButton.Types.Plain,
    iconType: type,
    accessibilityLabel: accessibilityLabel,
    onClick: onClick,
    tag: tag,
    target: target,
    href: href
  }, additionalIconProps) : _objectSpread({
    size: size || Icon.Sizes.Medium,
    type: type,
    accessibilityLabel: accessibilityLabel,
    color: color || sharedColor
  }, additionalIconProps);
  return /*#__PURE__*/React.createElement(IconContainer, {
    renderIconSpacer: renderIconSpacer,
    onClick: shouldBeButton ? function (e) {
      return e.stopPropagation();
    } : undefined,
    onKeyDown: shouldBeButton ? function (e) {
      return e.stopPropagation();
    } : undefined,
    side: side,
    iconAlignment: iconAlignment,
    shouldBeButton: shouldBeButton,
    size: size,
    columnProps: columnProps
  }, /*#__PURE__*/React.createElement(Component, props));
};

ConditionalIconButton.propTypes = {
  onClick: PropTypes.func,
  type: PropTypes.oneOfType([PropTypes.oneOf(Object.values(IconButton.Types)), PropTypes.oneOf(Object.values(Icon.Types))]),
  renderIconSpacer: PropTypes.bool,
  accessibilityLabel: PropTypes.string,
  size: PropTypes.oneOf(Object.values(Icon.Sizes)),
  sharedColor: PropTypes.oneOf(Object.values(Icon.Colors)),
  color: PropTypes.oneOf(Object.values(Icon.Colors)),
  iconAlignment: PropTypes.any,
  side: PropTypes.oneOf(Object.values(ListCellSide)),
  // Looks like because these props are added through the `allowedProps` call within
  // IconButton, TS is unable to see that these are valid
  tag: IconButton.propTypes.tag,
  target: IconButton.propTypes.target,
  href: IconButton.propTypes.href,
  iconProps: PropTypes.any
};

export { ConditionalIconButton as default };
